import { getStatuses } from '../../lib/statuses'
import { Key } from './Key'
import { useEffect } from 'react'
import { RiDeleteBack2Fill } from 'react-icons/ri';
import { IoMdCheckmarkCircle } from 'react-icons/io';
import { IconContext } from "react-icons";
import { ImInfo } from 'react-icons/im'

type Props = {
  onChar: (value: string) => void
  onDelete: () => void
  onEnter: () => void
  onShift: () => void
  onAlt: () => void
  onHint: () => void
  guesses: string[]
  isRevealing?: boolean
  isShifted: boolean
  isAlted: boolean
  uyirmei: string
}

export const Keyboard = ({
  onChar,
  onDelete,
  onEnter,
  onShift,
  onAlt,
  onHint,
  guesses,
  uyirmei,
  isRevealing,
  isShifted,
  isAlted,
}: Props) => {
  const charStatuses = getStatuses(guesses)

  const onClick = (value: string) => {
    if (value === 'ENTER') {
      onEnter()
    } else if (value === 'SHIFT') {
      onShift()
    } else if (value === 'ALT') {
      onAlt()
    } else if (value === 'DELETE') {
      onDelete()
    } else {
      onChar(value)
      if (isShifted) onShift()
    }
  }

  useEffect(() => {
    const listener = (e: KeyboardEvent) => {
      if (e.code === 'Enter') {
        onEnter()
      } else if (e.code === 'Backspace') {
        onDelete()
      } else if (e.key === 'Shift') {
        onShift()
      } else if (e.key === 'Alt') {
        onAlt()
      } else {
      //  const key = e.key.toUpperCase()
      // if (key.match(/[ஃ-வ]([ா-்]|)/gi)) {
      //  onChar(key)
        // if (
        //     e.key.length === 1 &&
        //     e.key >= 'ஃ' && e.key <= 'வ' && 
        //     !(e.key >= 'ா' && e.key <= '்')
        //   ) {
      }
    }
    window.addEventListener('keyup', listener)
    return () => {
      window.removeEventListener('keyup', listener)
    }
  }, [onEnter, onDelete, onShift, onAlt, onChar])

  if (isAlted) {

    return (
      <div> 
      <div className="flex justify-center mb-1 text-xl">
      {['','ா', 'ி', 'ீ'].map((key) => (
          <Key
            value={uyirmei.substr(uyirmei.length-2,1) + key}
            onClick={() => {onClick(uyirmei.substring(0,-2) + key); onAlt();}}
            status={charStatuses[uyirmei.substr(uyirmei.length-2,1) + key]}
            isRevealing={isRevealing}
          />
        ))}
        <div className="mx-0.5"></div>
      {['க்', 'ச்', 'ட்', 'த்', 'ப்', 'ற்'].map((key) => (
          <Key
            value={key}
            key={key}
            onClick={() => {onClick(key);}}
            status={charStatuses[key]}
            isRevealing={isRevealing}
          />
        ))}
      </div>
      <div className="flex justify-center mb-1 text-xl">
      {['ு', 'ூ', 'ெ', 'ே'].map((key) => (
          <Key
            value={uyirmei.substr(uyirmei.length-2,1) + key}
            onClick={() => {onClick(uyirmei.substring(0,-2) + key); onAlt();}}
            status={charStatuses[uyirmei.substr(uyirmei.length-2,1) + key]}
            isRevealing={isRevealing}
          />
        ))}
        <div className="mx-0.5"></div>
        {['ங்', 'ஞ்', 'ண்', 'ந்', 'ம்', 'ன்'].map((key) => (
          <Key
            value={key}
            key={key}
            onClick={() => {onClick(key);}}
            status={charStatuses[key]}
            isRevealing={isRevealing}
          />
        ))}
      </div>
      <div className="flex justify-center mb-1">
      {['ை', 'ொ','ோ','ௌ'].map((key) => (
          <Key
            value={uyirmei.substr(uyirmei.length-2,1) + key}
            onClick={() => {onClick(uyirmei.substring(0,-2) + key); onAlt();}}
            status={charStatuses[uyirmei.substr(uyirmei.length-2,1) + key]}
            isRevealing={isRevealing}
          />
        ))}
        <div className="mx-0.5"></div>
        {['ய்', 'ர்', 'ல்', 'வ்', 'ழ்', 'ள்'].map((key) => (
          <Key
            value={key}
            key={key}
            onClick={() => {onClick(key);}}
            status={charStatuses[key]}
            isRevealing={isRevealing}
          />
        ))}
      </div>
      <div className="flex justify-center mb-1 text-xl">
        <Key value="ஃ" key="ஃ" onClick={onClick} status={charStatuses["ஃ"]}></Key>
        <Key width={80} value="ENTER" onClick={() => {onEnter(); onAlt(); onShift();}}>
        நுழை&nbsp;<IconContext.Provider value={{ style: { verticalAlign: 'middle'}, color: 'green', size: '15px' }}> <IoMdCheckmarkCircle /></IconContext.Provider> 
        </Key>
        <Key width={80} value="DELETE" onClick={() => {onDelete(); onAlt(); }}>
        நீக்கு&nbsp;<IconContext.Provider value={{ style: { verticalAlign: 'middle'}, color: 'red', size: '15px' }}> <RiDeleteBack2Fill /></IconContext.Provider>
        </Key>
        <Key value="HINT" onClick={onHint}> <ImInfo></ImInfo></Key>
      </div>
      </div>
    )

  } else 

  if (isShifted) {

    return (
      //உயிர்மெய் Keyboard uyirmei.substr fix by நீச்சல்காரன் https://github.com/neechalkaran
      <div> 
      <div className="flex justify-center mb-1 text-xl">
      {['','ா', 'ி', 'ீ'].map((key) => (
          <Key
            value={uyirmei.substr(uyirmei.length-2,1) + key}
            onClick={() => {onClick(uyirmei.substring(0,-2) + key)}}
            status={charStatuses[uyirmei.substr(uyirmei.length-2,1) + key]}
            isRevealing={isRevealing}
          />
        ))}
        <div className="mx-0.5"></div>
      {['க்', 'ச்', 'ட்', 'த்', 'ப்', 'ற்'].map((key) => (
          <Key
            value={key}
            key={key}
            onClick={() => {onClick(key); onAlt();}}
            status={charStatuses[key]}
            isRevealing={isRevealing}
          />
        ))}
      </div>
      <div className="flex justify-center mb-1 text-xl">
      {['ு', 'ூ', 'ெ', 'ே'].map((key) => (
          <Key
            value={uyirmei.substr(uyirmei.length-2,1) + key}
            onClick={() => {onClick(uyirmei.substring(0,-2) + key)}}
            status={charStatuses[uyirmei.substr(uyirmei.length-2,1) + key]}
            isRevealing={isRevealing}
          />
        ))}
        <div className="mx-0.5"></div>
        {['ங்', 'ஞ்', 'ண்', 'ந்', 'ம்', 'ன்'].map((key) => (
          <Key
            value={key}
            key={key}
            onClick={() => {onClick(key); onAlt();}}
            status={charStatuses[key]}
            isRevealing={isRevealing}
          />
        ))}
      </div>
      <div className="flex justify-center mb-1">
      {['ை', 'ொ','ோ','ௌ'].map((key) => (
          <Key
            value={uyirmei.substr(uyirmei.length-2,1) + key}
            onClick={() => {onClick(uyirmei.substring(0,-2) + key)}}
            status={charStatuses[uyirmei.substr(uyirmei.length-2,1) + key]}
            isRevealing={isRevealing}
          />
        ))}
        <div className="mx-0.5"></div>
        {['ய்', 'ர்', 'ல்', 'வ்', 'ழ்', 'ள்'].map((key) => (
          <Key
            value={key}
            key={key}
            onClick={() => {onClick(key); onAlt();}}
            status={charStatuses[key]}
            isRevealing={isRevealing}
          />
        ))}
      </div>
      <div className="flex justify-center mb-1 text-xl">
        <Key value="ஃ" key="ஃ" onClick={onClick} status={charStatuses["ஃ"]}></Key>
        <Key width={80} value="ENTER" onClick={() => {onEnter(); onShift();}}>
        நுழை&nbsp;<IconContext.Provider value={{ style: { verticalAlign: 'middle'}, color: 'green', size: '15px' }}> <IoMdCheckmarkCircle /></IconContext.Provider> 
        </Key>
        <Key width={80} value="DELETE" onClick={() => {onDelete(); onShift();}}>
        நீக்கு&nbsp;<IconContext.Provider value={{ style: { verticalAlign: 'middle'}, color: 'red', size: '15px' }}> <RiDeleteBack2Fill /></IconContext.Provider>
        </Key>
        <Key value="HINT" onClick={onHint}> <ImInfo></ImInfo></Key>
      </div>
      </div>
    )

  } else {

  return (

    <div>
      <div className="flex justify-center mb-1 text-xl">
      {['அ', 'ஆ', 'இ', 'ஈ'].map((key) => (
          <Key
            value={key}
            key={key}
            onClick={onClick}
            status={charStatuses[key]}
            isRevealing={isRevealing}
          />
        ))}
        <div className="mx-0.5"></div>
      {['க்', 'ச்', 'ட்', 'த்', 'ப்', 'ற்'].map((key) => (
          <Key
            value={key}
            key={key}
            onClick={() => {onClick(key); onShift();}}
            status={charStatuses[key]}
            isRevealing={isRevealing}
          />
        ))}
      </div>
      <div className="flex justify-center mb-1 text-xl">
        {['உ', 'ஊ', 'எ', 'ஏ'].map((key) => (
          <Key
            value={key}
            key={key}
            onClick={onClick}
            status={charStatuses[key]}
            isRevealing={isRevealing}
          />
        ))}
        <div className="mx-0.5"></div>
        {['ங்', 'ஞ்', 'ண்', 'ந்', 'ம்', 'ன்'].map((key) => (
          <Key
            value={key}
            key={key}
            onClick={() => {onClick(key); onShift();}}
            status={charStatuses[key]}
            isRevealing={isRevealing}
          />
        ))}
      </div>
      <div className="flex justify-center mb-1 text-xl">
        {['ஐ', 'ஒ', 'ஓ', 'ஔ'].map((key) => (
          <Key
            value={key}
            key={key}
            onClick={onClick}
            status={charStatuses[key]}
            isRevealing={isRevealing}
          />
        ))}
        <div className="mx-0.5"></div>
        {['ய்', 'ர்', 'ல்', 'வ்', 'ழ்', 'ள்'].map((key) => (
          <Key
            value={key}
            key={key}
            onClick={() => {onClick(key); onShift();}}
            status={charStatuses[key]}
            isRevealing={isRevealing}
          />
        ))}
      </div>
        <div className="flex justify-center mb-1 text-xl">
        <Key value="ஃ" key="ஃ" onClick={onClick} status={charStatuses["ஃ"]}></Key>
        <Key width={100} value="ENTER" onClick={onClick}>
        நுழை&nbsp;<IconContext.Provider value={{ style: { verticalAlign: 'middle'}, color: 'green', size: '15px' }}> <IoMdCheckmarkCircle /></IconContext.Provider> 
        </Key>
        <Key width={100} value="DELETE" onClick={onClick}>
        நீக்கு&nbsp;<IconContext.Provider value={{ style: { verticalAlign: 'middle'}, color: 'red', size: '15px' }}> <RiDeleteBack2Fill /></IconContext.Provider>
        </Key>
        <Key value="HINT" onClick={onHint}> <ImInfo></ImInfo></Key>
      </div>
    </div>
  )
}
}